import { NavLink } from 'react-router-dom';
import { Home, History, User } from 'lucide-react';

const tabs = [
  { to: '/account', label: 'Home', icon: Home, testId: 'nav-home' },
  { to: '/history', label: 'History', icon: History, testId: 'nav-history' },
  { to: '/profile', label: 'Profile', icon: User, testId: 'nav-profile' },
];

export function BottomNav() {
  return (
    <nav className="fixed bottom-0 left-0 right-0 z-40 border-t border-black/10 bg-white/95 backdrop-blur-md">
      <div className="max-w-md mx-auto flex">
        {tabs.map(({ to, label, icon: Icon, testId }) => (
          <NavLink
            key={to}
            to={to}
            data-testid={testId}
            className={({ isActive }) =>
              `flex-1 flex flex-col items-center gap-1 py-3 text-xs font-medium transition-colors duration-150 ${
                isActive ? 'text-saffron' : 'text-muted-ink hover:text-charcoal'
              }`
            }
          >
            <Icon size={20} strokeWidth={2.2} />
            {label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
